import type { EventStatus } from "@/types/database";
import { Badge } from "@/components/ui/badge";
import {
  EVENT_STATUS_LABELS,
  EVENT_STATUS_BADGE_VARIANTS,
} from "@/utils/constants";

interface EventStatusBadgeProps {
  status: EventStatus;
}

export function EventStatusBadge({ status }: EventStatusBadgeProps) {
  return (
    <Badge variant={EVENT_STATUS_BADGE_VARIANTS[status]}>
      {EVENT_STATUS_LABELS[status]}
    </Badge>
  );
}
